import React, { Component } from 'react'
import "../../../../css/general-style.css"
import '../../../../css/small-table-responsive.css'
import '../../../PreSaleOrdersList.css'
import { NumberFormat } from '../../../../functions/generalFunctions';
import { pricesFormat } from '../../../../functions/pricesFormat';

import DashModalV2 from '../../../../components/DashModalV2';

export default class extends Component {

    constructor(props) {
        super(props);
        this.ModalLoading = React.createRef();

    }
    state = {
        showModal1: false,
        Detail: [],
        Title: '',
        Total: 0,
        TotalQuantity: 0
    }

    getGrandTotal() {
        const data = Array.isArray(this.props.data) ? this.props.data : []
        return data.reduce((acc, i) => ({
            Sales: acc.Sales + (Number(i.Total) || 0),
            Qty: acc.Qty + (Number(i.TotalNo) || 0)
        }), { Sales: 0, Qty: 0 })
    }

    handleModalOpen = (modal, Detail, Title, Sales, Total) => {
        const arr = Array.isArray(Detail) ? Detail : []
        this.setState({ [modal]: true, Detail: arr.slice(0, 500), Title: Title, Total: Sales, TotalQuantity: Total })
    }

    handleModalClose = (modal) => {
        this.setState({ [modal]: false, Detail: [], Title: '', Total: 0 })
    }

    // Same route -> color mapping the old table's row-border used (dashboard.css's
    // .route-* classes) — kept as inline hex here (2026-09-09 redesign) since the
    // card border is set via inline style, not a td:first-child CSS selector anymore.
    routeColor(route) {
        const r = (route || '').toLowerCase();
        if (r.includes('warehouse'))   return '#2563EB';
        if (r.includes('supermarket')) return '#10B981';
        if (r.includes('pallet'))      return '#8b5cf6';
        if (r.includes('distributor')) return '#F59E0B';
        if (r.includes('nebraska'))    return '#14b8a6';
        if (r.includes('atlanta') || r.includes('georgia'))  return '#06b6d4';
        if (r.includes('alabama') || r.includes('birmingham') || r.includes('tuscaloosa') || r.includes('montgomery')) return '#f97316';
        return '#94A3B8';
    }

    render() {
        const grandTotal = this.getGrandTotal()
        return (
            <>
            <div className='card'>
                <div className='card-body'>
                    <div className='row'>
                        <div className='col-sm-12'>
                            <h6 className='card-title-clean mb-0'>{this.props.Title}</h6>
                        </div>
                        <div className='col-sm-12'>
                            <div className='pb-3' />

                            {/* Vertical-only scroll, one card per customer (2026-09-09
                                redesign, client's ask: no horizontal scroll). */}
                            <div style={{ maxHeight: '55vh', overflowY: 'auto', paddingRight: '2px' }}>
                                {(this.props.data || []).slice(0, 400).map((order, o) => (
                                    <div key={`cust${o}`} className='pol-card' onClick={() => this.handleModalOpen('showModal1', order.Detail, order.CustomerName, order.Total, order.TotalNo)}
                                        style={{ borderLeft: `4px solid ${this.routeColor(order.Route)}`, padding: '14px 16px', marginBottom: '10px', cursor: 'pointer' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: '10px', flexWrap: 'wrap', marginBottom: '12px' }}>
                                            <strong style={{ fontSize: '0.95rem', color: '#0F172A' }}>{order.CustomerName}</strong>
                                            <strong style={{ fontSize: '1.05rem', color: '#2563EB' }}>${NumberFormat(pricesFormat(order.Total))}</strong>
                                        </div>
                                        <div className='pol-card__grid'>
                                            <div className='pol-kv-box'>
                                                <span>Route</span>
                                                <strong>{order.Route}</strong>
                                            </div>
                                            <div className='pol-kv-box'>
                                                <span>Customer No</span>
                                                <strong>{order.CustomerNo}</strong>
                                            </div>
                                            <div className='pol-kv-box'>
                                                <span># Of Sales</span>
                                                <strong>{order.TotalNo}</strong>
                                            </div>
                                        </div>
                                    </div>
                                ))}

                                <div className='pol-card' style={{ padding: '14px 16px', background: '#F8FAFC' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: '10px', flexWrap: 'wrap' }}>
                                        <strong style={{ fontSize: '0.95rem', color: '#0F172A' }}>TOTAL — {grandTotal.Qty} sales</strong>
                                        <strong style={{ fontSize: '1.05rem', color: '#2563EB' }}>${NumberFormat(pricesFormat(grandTotal.Sales))}</strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <DashModalV2
                title={'Customer: ' + this.state.Title}
                subtitle={`${this.state.TotalQuantity} invoices · $${NumberFormat(pricesFormat(this.state.Total))} total`}
                show={this.state.showModal1}
                onClose={() => this.handleModalClose('showModal1')}
            >
                <div className="tableFixHeadSmall">
                    <table className='table table-clean'>
                        <thead>
                            <tr>
                                <th>Invoice No</th>
                                <th>Route</th>
                                <th>Date</th>
                                <th className='text-end'>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.Detail.map((order, o) => (
                                <tr key={o}>
                                    <td>{order.InvoiceNo}</td>
                                    <td>{order.UDF_RUTA}</td>
                                    <td className='text-center'>{new Date(order.InvoiceDate).toLocaleDateString()}</td>
                                    <td className='text-end'>${NumberFormat(pricesFormat(order.NonTaxableSalesAmt))}</td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot className='tfoot'>
                            <tr>
                                <td className='textTableSize fw-bold'>Totals</td>
                                <td></td>
                                <td className='textTableSize text-center fw-bold'>{this.state.TotalQuantity} inv</td>
                                <td className='textTableSize text-end fw-bold'>${NumberFormat(pricesFormat(this.state.Total))}</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </DashModalV2>
            </>
        )
    }
}
